export enum FrameStyleEnum {
  BEVELED = 'Beveled',
  CONVEX = 'Convex',
  SQ_BEAD = 'Sq bead',
}
